<template>
  <section
    :class="{
      'section-builder-custom-table': true,
      'w-full': fullWidthContent,
      'container mx-auto': !fullWidthContent,
    }"
  >
    <GeneralTheme :theme="configuration">
      <CustomTable
        v-if="customTable"
        v-bind="customTable"
        :mobile-responsive
        :border
        :striped-rows
      />
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import CustomTable from './CustomTable.vue';
import type { SectionBuilderCustomTable } from '~/sanity/types';

defineProps<SectionBuilderCustomTable>();
</script>
